/* eslint-disable vue/multi-word-component-names */

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";

import "@/assets/css/global.css";
import "primeicons/primeicons.css";

import InputRequiredNumber from "@/components/elements/InputRequiredNumber.vue";
import InputRequiredText from "@/components/elements/InputRequiredText.vue";
import InputRequiredTextArea from "@/components/elements/InputRequiredTextArea.vue";
import DropDownRequire from "@/components/elements/drop-down.vue";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from 'primevue/inputnumber';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Select from "primevue/select";
import Checkbox from "primevue/checkbox";
import TabPanel from "primevue/tabpanel";
import SplitButton from "primevue/splitbutton";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import Badge from "primevue/badge";
import OverlayBadge from "primevue/overlaybadge";
import Avatar from "primevue/avatar";
import Password from "primevue/password";
import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";
import ToggleSwitch from 'primevue/toggleswitch';
// import { Form, FormField } from '@primevue/forms';
import Textarea from 'primevue/textarea';
import Knob from 'primevue/knob';
import Dialog from 'primevue/dialog';
import DatePicker from 'primevue/datepicker';
import FileUpload from 'primevue/fileupload';
import Stepper from 'primevue/stepper';
import StepList from 'primevue/steplist';
import StepPanels from 'primevue/steppanels';
import StepItem from 'primevue/stepitem';
import Step from 'primevue/step';
import StepPanel from 'primevue/steppanel';
import RadioButton from 'primevue/radiobutton';
import Tag from 'primevue/tag';
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import Paginator from 'primevue/paginator';
import MultiSelect from 'primevue/multiselect';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import Chart from 'primevue/chart';
import Chip from "primevue/chip";
import Menu from 'primevue/menu';
import InputOtp from 'primevue/inputotp';



// import ToggleSwitch from 'primevue/toggleswitch';


import 'primeflex/primeflex.css';


const app = createApp(App);

app.use(store);
// app.use(PrimeVue);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: ".fake-dark-selector", // A class that doesn't exist
    },
  },
});

// app.use(Toast);
app.use(router);
app.use(ToastService);
app.component("Toast", Toast);

app.component("InputRequiredNumber", InputRequiredNumber);
app.component("InputRequiredText", InputRequiredText);
app.component("InputRequiredTextArea", InputRequiredTextArea);
app.component("DropDownRequire", DropDownRequire);
app.component('InputNumber', InputNumber);
app.component("Button", Button);
app.component("InputText", InputText);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("Select", Select);
app.component("Checkbox", Checkbox);
app.component("TabPanel", TabPanel);
app.component("Tabs", Tabs);
app.component("TabList", TabList);
app.component("Tab", Tab);
app.component("TabPanels", TabPanels);
app.component("SplitButton", SplitButton);
app.component("InputGroup", InputGroup);
app.component("InputGroupAddon", InputGroupAddon);
app.component("Badge", Badge);
app.component("OverlayBadge", OverlayBadge);
app.component("Avatar", Avatar);
app.component("Password", Password);
app.component("ToggleSwitch", ToggleSwitch);
// app.component("Form", Form);
// app.component("FormField", FormField);
app.component("Textarea", Textarea);
app.component("Knob", Knob);
app.component("Dialog", Dialog);
app.component("DatePicker", DatePicker);
app.component("FileUpload", FileUpload);
app.component("Stepper", Stepper);
app.component("StepList", StepList);
app.component("StepPanels", StepPanels);
app.component("StepItem", StepItem);
app.component("Step", Step);
app.component("StepPanel", StepPanel);
app.component("RadioButton", RadioButton)
app.component("Tag", Tag)
// app.component("ToggleSwitch", ToggleSwitch)
app.component("Accordion", Accordion)
app.component("AccordionPanel", AccordionPanel)
app.component("AccordionHeader", AccordionHeader)
app.component("AccordionContent", AccordionContent)
app.component("Paginator", Paginator);
app.component("MultiSelect", MultiSelect);
app.component("Chart", Chart);
app.component("Chip",Chip);
app.component("Menu",Menu);
app.component('InputOtp', InputOtp);

app.mount("#app");
